import { render, staticRenderFns } from "./ModelAICdiv.vue?vue&type=template&id=7ce4f7a6&scoped=true&"
import script from "./ModelAICdiv.vue?vue&type=script&lang=js&"
export * from "./ModelAICdiv.vue?vue&type=script&lang=js&"
import style0 from "./ModelAICdiv.vue?vue&type=style&index=0&id=7ce4f7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce4f7a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardText,VIcon})
